import React, { Dispatch, SetStateAction } from "react";

export interface SidebarContextProps {
	isSidebarOpen: boolean;
	isConfigOpen: boolean;
	setIsSidebarOpen: Dispatch<SetStateAction<boolean>>;
	setIsConfigOpen: Dispatch<SetStateAction<boolean>>;
}

export default React.createContext<Partial<SidebarContextProps>>({});
